import { EventSourcePolyfill } from 'event-source-polyfill';
import { ListSort } from '@/components/List/types';
import { ADDTYPE } from '@/pages/list/components/ExportData/type';
import axios from '@/services/axios';
import { getAPIPrefix, getLocalToken } from '@/utils';
import { workerAxios } from '@/utils/worker';

import { axiosWrapper } from '../authorized';

export * from './graph';

// 名词解释
export const getExplanationApi = (keyword: string, reload?: boolean): EventSource => {
  return new EventSourcePolyfill(
    getAPIPrefix(`/llm/glossary?word=${keyword}${reload ? '&reload=true' : ''}`),
    {
      headers: {
        Authorization: getLocalToken(),
      },
    },
  );
};

// 技术概览
export const GetOverViewApi = (searchSetting: Req.SearchSetting): Promise<Res.GetOverViewApi> =>
  axios.post(`/pub/v1/GetOverView`, { searchSetting });

// 技术概览
export const GetOverViewApiv2 = (searchSetting: Req.SearchSetting): Promise<Res.GetOverViewApi> =>
  axios.post(`/pub/v1/GetOverViewv2`, { searchSetting });

// 检索式实体抽取
// export const searchesSplitApi = (searches: string) =>
//   axios.post(`/llm/searches/split`, {
//     searches: searches,
//   });
export const searchesSplitApi = (searches: string) =>
  workerAxios(`/llm/searches/split`, {
    searches: searches,
  });

/**
 * 
输入长度限制：2300字；总输入输出4096 tokens
中文为字数，英文为单词数，标点符号算1个字
lastEventId 长度为5位或者6位 就是有问题 其他都没问题
 */
// export const GetSummaryAnalysis = ({ data, operation, reload }, option?: any) => {
//   return axios.post(`/llm/summary/context`, { operation: operation, data: data }, option).then(
//     (res) =>
//       new EventSourcePolyfill(
//         getAPIPrefix(
//           `/llm/summary?context_id=${res.context_id}${reload >= 0 ? '&reload=true' : ''}`,
//         ),
//         {
//           headers: {
//             Authorization: getLocalToken(),
//           },
//         },
//       ),
//   );
// };
export const GetSummaryAnalysis = ({ data, operation, reload }, option?: any) => {
  return workerAxios(`/llm/summary/context`, { operation: operation, data: data }, option).then(
    (res) =>
      new EventSourcePolyfill(
        getAPIPrefix(
          `/llm/summary?context_id=${res.context_id}${reload >= 0 ? '&reload=true' : ''}`,
        ),
        {
          headers: {
            Authorization: getLocalToken(),
          },
        },
      ),
  );
};

/**
 * 
输入长度限制：2300字；总输入输出4096 tokens
中文为字数，英文为单词数，标点符号算1个字
lastEventId 长度为5位或者6位 就是有问题 其他都没问题
 */
export const getSummaryContextService = (payload: any, option?: any) => {
  return axios.post(`/llm/summary/context`, payload, option);
};

export const EventSource2Promise = (
  params: { data: any; operation: any; reload?: any },
  option,
  mySource?: any,
) => {
  const { data, operation, reload } = params;
  return GetSummaryAnalysis({ data, operation, reload }, option).then((source) => {
    return new Promise((resolve, reject) => {
      source.addEventListener('finish', (e) => {
        source.close();
        // 遇到类似登录的问题话 也算是失败 或者返回的数据为空
        if (e?.lastEventId?.length == 5 || e?.lastEventId?.length == 6 || !e.data) {
          reject(e);
        } else {
          resolve(e.data);
        }
      });
      source.addEventListener('error', (e) => {
        source.close();
        reject(e);
      });
      source.addEventListener('add', (e) => {
        if (mySource) {
          mySource(source);
        }
      });
    });
  });
};

// 翻译
export const GetTranslateApi = (id: string, lang: 'en' | 'zh') => {
  return axios.post(`/pub/v1/GetPubInfoByIdLang`, { pub_id: id, lang: lang });
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     reject(true)
  //   }, 1000);
  // })
};

//获取论文列表
export const GetPubListApi = (
  searchSetting: { searcher: string; only_pdf?: boolean; [key: string]: any },
  sort: ListSort,
  size: number = 10,
  offset: number = 0,
) => {
  return axios.post(`/pub/v1/GenPubListBySearches`, {
    searchSetting,
    sort,
    size,
    offset,
  });
};

//获取学者列表
export const GetAuthorListApi = (
  searchSetting: { searcher: string },
  sort: ListSort,
  size: number = 10,
  offset: number = 0,
) => {
  return axios.post(`/pub/v1/GenPersonListBySearches`, {
    searchSetting,
    sort,
    size,
    offset,
  });
};

/**
 * 获取机构列表
 */
export const GetOrgListApi = (
  searchSetting: { searcher: string; [index: string]: any },
  sort: ListSort,
  size = 10,
  offset = 0,
) => {
  return axios.post(`/pub/v1/GenOrgListBySearches`, {
    searchSetting,
    sort,
    size,
    offset,
  });
};

/**
 * 获取全景图数据
 * @param id
 */
export const getPanoramaData = (id: string) => {
  return axios.post(`/techgraph/v1/GetTechGraphByIdV2`, {
    project_id: id,
  });
};

/**
 * 获取全景图列表
 */
export const getPanoramaList = () => {
  return axios.post(`/techgraph/v1/GetTechgraphProjectV2`);
};

// 通过 label 获取详细的检索式信息，解决 url 长度过长的问题；

export const getTechGraphNodeById = (node_id: any, tree_id: stirng) => {
  return axios.post(`/techgraph/v1/GetTechGraphNodeByIdV2`, { node_id, tree_id });
};

// 查询
export const GenAggregationDataApi = ({
  agg_type,
  searchSetting,
  size,
}: Req.GenAggregationDataApi) => {
  return axios.post(`/pub/v1/GenAggregationData`, {
    searchSetting,
    agg_type: agg_type,
    size: size || 2,
  });
};

// 搜索
export const GetAggregationDataByNameApi = ({
  agg_type,
  searchSetting,
  keyword,
}: Req.GenAggregationDataApi) => {
  return axios.post(`/pub/v1/GetAggregationDataByName`, {
    searchSetting,
    keyword,
    agg_type,
  });
};

interface Props {
  tree_id: string;
  node_id: string;
  search_key: 'pub' | 'person' | 'org';
  offset: number;
  size: number;
}
export const getSelectedPageByNodeId = (params: Props) => {
  return axios.post(`/pub/v1/GetSelectedPageByNodeId`, params);
};

export const onDeleteExportRecords = (ids: string[]) => {
  return axiosWrapper(axios.post(`/information/v1/deleteExportRecords`, { ids }));
};

export const onGetExportRecords = (type) => {
  return axiosWrapper(
    axios.get(`/information/v1/getExportRecords?type=${type}&offset=0&size=999&sort=-create_time`),
  );
};
// getAISummaryPubs
export const onGetAISummaryPubs = (type: 1) => {
  return axiosWrapper(
    axios.get(`/information/v1/getAISummaryPubs?type=${type}&offset=0&size=50&sort=-create_time`),
  );
};
// 添加综述论文
export const onAddAISummaryPubs = (param: { id: string; title: string; type: 1 }) => {
  return axiosWrapper(axios.post(`/information/v1/addAISummaryPubs`, param));
};

//添加导出数据
interface GetAddExportRecords {
  id: string; // 对应实体id
  type: 1 | 2 | 3 | 4 | 5; // 类型：1-论文、2-学者、3-专利、4-项目、5-机构
  title: string; // 标题
  pub_num?: number; // 机构论文数量，如果是5-机构需要传
  person_num?: number; // 机构学者数量，如果是5-机构需要传
  n_citation?: number; // 机引用数量，如果是5-机构需要传
}
export const onAddExportRecords = (param: GetAddExportRecords[]) => {
  return axiosWrapper(axios.post(`/information/v1/addExportRecords`, { list: param }));
};

// deleteAISummaryPubs
export const onDeleteAISummaryPubs = (ids: string[]) => {
  return axiosWrapper(axios.post(`/information/v1/deleteAISummaryPubs`, { ids }));
};
// exportEntityRecords
interface detailsItem {
  id: string;
  entity_id: string;
}

interface exportEntityRecordsProps {
  details: detailsItem[];
  type: ADDTYPE; //类型：1-论文、2-学者、3-专利、4-项目、5-机构
}
export const exportEntityRecords = (list: exportEntityRecordsProps[]) =>
  axios.post(`/information/v1/exportEntityRecords`, { list }, { responseType: 'blob' });

// 删除导出历史记录
export const onDeleteExportHistory = (ids: string[]) => {
  return axiosWrapper(axios.post(`/information/v1/deleteExportRecordsHistory`, { ids }));
};
// 查询导出数据历史
interface propsType {
  type: ADDTYPE | -1;
  offset: number;
  start_time: string;
  end_time: string;
}
export const onGetExportHistory = (param: propsType) => {
  const { type = -1, offset = 0, start_time, end_time } = param;
  return axiosWrapper(
    axios.get(
      `/information/v1/getExportRecordsHistory?start_time=${start_time}&end_time=${end_time}&type=${type}&offset=${offset}&size=99999999&sort=-create_time`,
    ),
  );
};

/**
 * 删除导出历史
 */
export const onDeleteExportRecordsHistory = (ids: string[]) => {
  return axiosWrapper(
    axios.post(`/information/v1/deleteExportRecordsHistory`, {
      ids,
    }),
  );
};
// genAISummary
export const genAISummary = (params: { details: detailsItem[]; topic: string }) => {
  return axiosWrapper(axios.post(`/information/v1/genAISummary`, params));
};

//deleteAISummary
export const onDeleteAISummary = (id: string) =>
  axiosWrapper(axios.post(`/information/v1/deleteAISummary`, { id }));
